import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { Conversation } from '../interfaces/conversation.interface';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { inject } from '@angular/core';

type BooksState = {
  conversations: Conversation[];
  isLoading: boolean;
  userId: string;
};

const initialState: BooksState = {
  conversations: [],
  isLoading: false,
  userId: localStorage.getItem('userId') ?? crypto.randomUUID(),
};
// Change dbService to API service
export const ConversationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, dbService = inject(NgxIndexedDBService)) => {
    return {
      addConversation(conversation: Conversation) {
        dbService.add('conversations', conversation).subscribe();
        patchState(store, (state) => ({
          conversations: [conversation, ...state.conversations],
        }));
      },
      removeConversation(bookId: string) {
        dbService.delete('conversations', bookId).subscribe();
        patchState(store, (state) => ({
          conversations: state.conversations.filter(
            (book) => book.id !== bookId,
          ),
        }));
      },
      updateConversation(book: Conversation) {
        dbService.update('conversations', book).subscribe();
        patchState(store, (state) => ({
          conversations: state.conversations.map((b) =>
            b.id === book.id ? book : b,
          ),
        }));
      },
      getConversations() {
        dbService
          .getAllByIndex<Conversation>(
            'conversations',
            'userId',
            IDBKeyRange.only(store.userId()),
          )
          .subscribe((conversations) => {
            patchState(store, {
              conversations: conversations.sort(
                (a, b) => b.createdAt.valueOf() - a.createdAt.valueOf(),
              ),
            });
          });
      },
      getConversation(id: string) {
        return store
          .conversations()
          .find((conversation) => conversation.id === id);
      },
      reset() {
        patchState(store, initialState);
      },
    };
  }),
);
